<ion-grid class="table height-toolbar-{{toolbar}} loading ion-justify-content-center ion-align-items-center">
  <ion-spinner name="dots"></ion-spinner>
</ion-grid>
